// Présentation des demandes de Suspension / Remobilisation : tons et libellés
// partagés par la fiche allocataire, sa timeline et la page du Directeur.
// Les libellés métier viennent de l'API (outcomeLabel, statusLabel) ; ici
// ne vivent que les tons et quelques textes d'interface.

export const STATUT_TONES = {
  A_TRAITER: "muted",
  EN_ATTENTE_VALIDATION: "warn",
  VALIDEE: "ok",
  REFUSEE: "ko",
  LEVEE_DE_SAISINE: "neutral",
};

export const STATUT_COLORS = {
  A_TRAITER: "body",
  EN_ATTENTE_VALIDATION: "warning",
  VALIDEE: "success",
  REFUSEE: "danger",
  LEVEE_DE_SAISINE: "dark",
};

// Motifs de refus du Directeur — miroir de MotifRefusRemobilisation côté API :
// liste du métier (CE-1333), complétée le 19/10/2026 par « Absence de remobilisation ».
export const MOTIFS_REFUS = [
  { id: "REMOBILISATION_HORS_PERIODE_SANCTION", label: "Remobilisation hors période sanction" },
  { id: "ABSENCE_DE_REMOBILISATION", label: "Absence de remobilisation" },
];

export const STATUTS_ACTIFS = ["A_TRAITER", "EN_ATTENTE_VALIDATION"];

export const estEnAttenteValidation = (demandes = []) =>
  (demandes || []).some((d) => d.status === "EN_ATTENTE_VALIDATION");

// Qui demande : l'agent, ou l'origine partenaire (France Travail) quand il n'y a pas d'agent.
export const demandeur = (d) => nomComplet(d?.requestedBy) || d?.requestedBy?.id || (d?.requestedBy ? null : d?.originLabel) || null;

export const nomComplet = (personne) =>
  personne ? [personne.lastname, personne.firstname].filter(Boolean).join(" ") : "";
